import { useEffect, useState } from "react";
import {
  Drawer,
  DrawerContent,
  DrawerLink,
  DrawerLinks,
} from "../styled/Header.styled";
import {
  MENU_BY_TITLE,
  getHeaderLink,
} from "./data";
import { Container } from "@mui/material";

export const PCDrawer = ({ isOpen, content, onMouseEnter, onMouseLeave }) => {
  const [drawerContent, setDrawerContent] = useState(null);

  useEffect(() => {
    setDrawerContent(content ? MENU_BY_TITLE[content] : null);
  }, [content]);

  return (
    <Drawer
      className={isOpen ? "open" : "close"}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Container>
        <DrawerContent>
          {
          content &&
            drawerContent &&
            Object.entries(drawerContent).map(([category, items]) => (
              <DrawerLinks>
                <a href={getHeaderLink(category)} className="link-title">
                  {category}
                </a>
                {items.map((item, index) => (
                  <DrawerLink key={index}>
                    <a href={item.link}>{item.title}</a>
                  </DrawerLink>
                ))}
              </DrawerLinks>
            ))}
        </DrawerContent>
      </Container>
    </Drawer>
  );
};
